import ReactGA from "react-ga4";
import Button from '@mui/material/Button';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Grid, Snackbar } from '@mui/material';
import Typography from '@mui/material/Typography';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useContext, useEffect, useState } from 'react';

import { PATHS } from "../type/EnumPaths";
import { ShoppingCartContext } from "../util/useContext";
import { shoppingCartAdd } from "../util/shoppingCartAdd";
import { storeShoppingCart } from "../util/storeShoppingCart";

type PayButtonProps = {
  productName: string;
  productId: string;
}

const buttonSx = { maxWidth: "100%", width: "220px", textTransform: "unset" };

const PayButtons = (props: PayButtonProps) => {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState("");
  const navi = useNavigate();

  useEffect(() => {
    if (props.productName) setLink(`https://wa.me/6580445346?text=Hi,%20I%20am%20interested%20in%20the%20${props.productName}%20`)
    else setLink("https://wa.me/6580445346?text=Hi,%20I%20am%20interested%20in%20")
  }, [props.productName])

  const { shoppingCartString, setShoppingCart } = useContext(ShoppingCartContext);

  const handleClick = () => {
    setOpen(true);
    ReactGA.event({ category: "Conversion", action: "Copied email address" });
    navigator.clipboard.writeText("enquiry@audio500.com");
  };

  const handleAddToCart = () => {
    const latestShoppingCartString = shoppingCartAdd(shoppingCartString, props.productId, 1);
    setShoppingCart(latestShoppingCartString);
    storeShoppingCart(latestShoppingCartString);
  }

  const handleBuyNow = () => {
    handleAddToCart();
    navi(`/${PATHS.CHECKOUT}`);
  }

  return (
    <Grid container spacing={1} style={{ paddingTop: "20px" }}>
      <Grid item xs={12}>
        <Button
          color="yellow"
          variant={"contained"}
          sx={buttonSx}
          onClick={handleAddToCart}
        >
          Add to Cart
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant={"contained"}
          color="orange"
          sx={buttonSx}
          onClick={handleBuyNow}
        >
          Buy Now
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant={"contained"}
          sx={buttonSx}
          onClick={() => navi(`/${PATHS.CHECKOUT}`)}
        >
          Checkout or Get Quotation
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          aria-label="Order on WhatsApp"
          to={link}
          color="success"
          startIcon={<WhatsAppIcon />}
          target="_blank"
          sx={buttonSx}
          component={RouterLink}
        >
          Talk to Us
        </Button>
      </Grid>
      <Grid item>
        <Typography
          component={"span"}
          variant={"subtitle2"}
          onClick={handleClick}
          sx={{ cursor: "pointer"}}
        >
          or email us at enquiry@audio500.com
        </Typography>
      </Grid>
      
      <Snackbar
        message='"enquiry@audio500.com" copied to clibboard'
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
        open={open}
      />
    </Grid>
  )
}

export default PayButtons;